import Vue from 'vue';

const VUE_APP_AUTH_BASE_URL = process.env.VUE_APP_AUTH_BASE_URL;

const isLocal = process.env.VUE_APP_ENV === 'local';

export const refreshTokenRequest = (refreshToken) => {
  return Vue.axios.post(`${VUE_APP_AUTH_BASE_URL}/authorization/refresh-token`, {
    refresh_token: refreshToken,
    ...(isLocal && { returnTokens: true }),
  });
};
